import { createStructuredSelector } from 'reselect';
import {
  clientConfigSelector,
  importStatusSelector,
  officeSelector,
  propertyListSelector,
  propertySelector,
  queryStringSelector,
  searchResultConfigSelector,
} from '../../selectors/global';

export default createStructuredSelector({
  property: propertySelector,
  propertyList: propertyListSelector,
  queryString: queryStringSelector,
  clientConfig: clientConfigSelector,
  searchResultConfig: searchResultConfigSelector,
  office: officeSelector,
  importStatus: importStatusSelector,
});
